import styled from 'styled-components'

import { HeightClass } from '~/utils/enum/classes'
import { Variant as TextClass, typographyMap } from '../Text/Text.styles'

export const Container = styled.div<{ type: string; heightClass: HeightClass }>`
  max-width: 356px;
  border-radius: 8px;

  padding: ${({ theme, heightClass }) =>
    theme.mouseOver.sizes[heightClass].padding}px;

  background-color: ${({ theme, type }) => theme.feedbackCard.type[type]};

  @media (max-width: 767px) {
    margin: auto;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Title = styled.h2<{ heightClass: HeightClass }>`
  ${({ theme, heightClass }) =>
    typographyMap[
      theme.mouseOver.sizes[heightClass].titleTextClass as TextClass
    ]}

  margin-bottom: 0;
  color: ${({ theme }) => theme.colors.blackText};
`

export const Description = styled.p<{ heightClass: HeightClass }>`
  ${({ theme, heightClass }) =>
    typographyMap[
      theme.mouseOver.sizes[heightClass].descriptionTextClass as TextClass
    ]}

  color: ${({ theme }) => theme.colors.blackText};
  margin: 0.5rem 0 0;
`

export const IconButton = styled.button`
  background: transparent;
  border: none;
  padding: 0;

  &:focus {
    box-shadow: unset !important;
  }

  > figure:focus {
    outline: unset !important;
  }

  &:hover {
    opacity: 0.8;
  }
`

export const MouseOverContainer = styled.div`
  position: absolute;
`

export const Connector = styled.div`
  position: absolute;
  left: 34px;
`

export const Arrow = styled.div`
  height: 12px;
  width: 2px;
  background-color: #006bff;
`

export const Dot = styled.div<{ alignment?: 'top' | 'bottom' }>`
  border-radius: 50%;
  background-color: #006bff;
  width: 4px;
  height: 4px;
  position: absolute;
  ${({ alignment }) => alignment === 'top' && 'top: -3px;'}
  left: -1px;

  ::before {
    content: '';
    border-radius: 50%;
    position: absolute;
    top: -4px;
    left: -4px;
    opacity: 0.2;
    display: block;
    width: 12px;
    height: 12px;
    background-color: #006bff;
  }
`
